import React from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';

import RootNavbar from '../../components/Navbars/RootNavbar/RootNavbar';
import ROUTES from '../../routes/routes';

class AuthLayout extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      collapse: false,
      layoutPath: '',
    };
  }

  componentDidMount() {
    this.props.verifyLoggedUser();
  }

  componentDidUpdate() {
    if (window.location.hash !== this.state.layoutPath) {
      this.props.verifyLoggedUser();
      this.setState({ layoutPath: window.location.hash });
    }
  }

  getRoutes = (routes) => {
    const res = routes.map((route) => {
      if (route.path === '/*') {
        return (
          <Route
            path={route.path}
            element={<Navigate to="/login" />}
            key={route.name}
          />
        );
      }
      return (
        <Route
          path={route.path}
          element={
            <route.component
              location={this.props.location}
              history={this.props.history}
            />
          }
          key={route.name}
        />
      );
    });
    return res;
  };

  handleOnColapsedMenu = () => {
    this.setState({
      collapse: !this.state.collapse,
    });
  };

  render() {
    return (
      <div className="auth-layout">
        <RootNavbar handleOnColapsedMenu={this.handleOnColapsedMenu} />
        <div className="auth-layout-content">
          <Routes>{this.getRoutes(ROUTES.AUTH)}</Routes>
        </div>
      </div>
    );
  }
}
export default AuthLayout;
